module.exports = __webpack_public_path__ + "assets/img/no-data.e0d23935.png";